<template>
    <div class="v-field" :class="{ 'v-field--inline' : inline }">
        <div
        :is="comp"
        :yesno="(field.type != 'image')"
        @ok="saveClick"
        @cancel="cancel">
            <div v-if="!inline" v-cloak slot="title">{{ $t('Edit') }} <span v-if="field.title" v-text="field.title"></span><span v-else>{{ $t('Field: ' + name) }}</span></div>
            <div v-cloak slot="message">
                <div>
                	<div v-if="field.type == 'contacts' && field.options">
						<MultiSelect
						v-model="value"
						:options="field.options"
						:defaultValue="value" />
                	</div>
                	<div v-else-if="field.type == 'map'">
						<StaticGmaps
						v-model="value"
						:defaultWidth="(typeof field.options.cwidth != 'undefined' ? field.options.cwidth : 600)"
						:defaultHeight="(typeof field.options.cheight != 'undefined' ? field.options.cheight : 600)"
						></StaticGmaps>
                	</div>
                	<div v-else-if="field.type == 'contact' && field.options" :class="'v-field__input--' + field.id">
                		<selectize v-focus v-model="value">
							<option v-for="opt in field.options" :key="opt.value" :value="opt.value">{{ (opt.translate ? $t(opt.label).trim() : opt.label) }}</option>
						</selectize>
                	</div>
                	<div v-else-if="field.type == 'image'">
                		<CroppableImage
                		v-if="$store.getters['features/croppa'] && (field.options.width || field.options['max-width']) && (field.options.height || field.options['max-height'])"

						:fieldname="field.id"
                		:id="field.assetID"
                		:cid="chart.id"
                		:pid="presentation.id"

                		:width="field.options.width ? parseInt(field.options.width) : parseInt(field.options['max-width'])"
                		:height="field.options.height ? parseInt(field.options.height) : parseInt(field.options['max-height'])"
						@saved="save"
                		></CroppableImage>
						<div v-else>
	                		<vue-dropzone ref="dropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
	                		<div  v-if="field.options">
	                			<div v-for="(value, name) in field.options">{{name}}: {{value}}</div>
	                		</div>
	                	</div>
                	</div>
                    <textarea v-focus v-else-if="field.type == 'textarea'" class="st-input st-input--full st-input--text" v-model="value" :rows="(field.attributes &&field.attributes.rows ? field.attributes.rows : 3)"></textarea>
                    <trumbowyg v-focus v-else-if="field.type == 'wysiwyg'" v-model="value" :config="{btns: [['removeformat'], ['bold', 'italic'], ['unorderedList', 'orderedList'], ['link']]}"></trumbowyg>

                    <input v-focus v-else-if="inline" class="inline-field st-input--text" v-on:keyup.enter="save" type="text" v-model="value" :class="'v-field__input--' + field.id">
                    <input v-focus v-else class="st-input st-input--full st-input--text" v-on:keyup.enter="save" type="text" v-model="value" :class="'v-field__input--' + field.id">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CroppableImage from '@/components/CroppableImage';

import help_general from '@/helpers/general';
import vueDropzone from 'vue2-dropzone';

import 'vue2-dropzone/dist/vue2Dropzone.css'
import Selectize from 'vue2-selectize';
import MultiSelect from '@/components/MultiSelect';

import StaticGmaps from '@/components/StaticGmaps';

export default {
  	name: 'v-field',
  	components: {
  		CroppableImage,
	  	StaticGmaps,
	    vueDropzone,
	    Selectize,
	    MultiSelect
  	},
	computed: {
		presentation(){
			return this.$store.getters.presentation;
		},
		comp(){
			if(this.inline) return 'v-toolinline';
			const el = this.$store.getters.active_field.element;
			if(el && window.innerHeight > 900){
			 	return 'v-tooldown';
			}
			return 'v-modal';
		},
		activefield(){
			return this.$store.getters.active_field;
		},
		field(){
			return this.$store.getters.getChartField(this.activefield.chartid, this.activefield.fieldname);
		},
		activefieldelement(){
			return this.$store.getters.active_field.element;
		}
	},
	props: {
		inline: {
			type: Boolean,
			default: false
		},
		chart: {
			type: Object,
			default: function(){
				return {};
			}
		},
		name: {
			type: String,
			default: ''
		}
	},
  data() {
  		const channel = this.$store.getters.channel;
  		const self = this;
		return {
			escSub: false,
			fileEl: null,
			value: '',
			croppaOptions: {},
			dropzoneOptions: {
				init: function () {
					this.on("complete", function (file) {
			            self.save(file);
			        });
			    },
				paramName: '',
				maxFiles: 1,
				addRemoveLinks: true,
				url: channel.urls.presentationchart.replace(':id', this.$store.getters.presentation.id).replace(':chart', this.chart.id),
				thumbnailWidth: 400,
				thumbnailHeight: 300,
				maxFilesize: 5 // 5 MB
	      	}
		};
	},
	created(){

		if(this.field.type == 'image' && this.field && this.field.renderd){
			this.value = this.field.renderd;
		} else {
			this.value = this.field.value;
		}
		this.dropzoneOptions.paramName = this.field.id;
	},
	mounted(){
		if(window.evn) this.escSub = window.evn.subscribe('esc', this.cancel);
		if(this.$refs.dropzone){
			const size = (this.field.size ? this.field.size : 0);
			var mockFile = { name: help_general.basename(this.value), size};
			this.$refs.dropzone.manuallyAddFile(mockFile, this.value);
		}
	},
	destroyed(){
		if(this.escSub) {
			this.escSub.remove();
			this.escSub = false;
		}
	},
	methods: {
		saveClick(){
			if(this.field.type == 'image'){
				this.$store.commit('RESET_ACTIVE_FIELD');
			} else {
				this.save();
			}
		},
		save(file){
			console.log('emit save');
			if(this.field.type == 'image'){
				if(this.$store.getters['features/croppa'] && (this.field.options.width || this.field.options['max-width']) && (this.field.options.height || this.field.options['max-height']) && file.url){
					this.$store.commit('UPDATE_FIELD', {
						id: this.chart.id,
						fieldname: this.name,
						assetID: file.id,
						default: file.url,
						renderd: file.url,
						value: file.url
					});
					this.$store.commit('RESET_ACTIVE_FIELD');
				} else if(file && file.xhr){ // alelös andere ist nicht echt
					let reps = JSON.parse(file.xhr.response);
					this.$store.commit('UPDATE_FIELD', {
						id: this.chart.id,
						fieldname: this.name,
						renderd: reps.message[this.name].url,
						value: reps.message[this.name].url
					});
				}
			} else if(this.field.type == 'map'){
				this.$store.commit('UPDATE_FIELD', {
					id: this.chart.id,
					fieldname: this.name,
					value: this.value,
					renderd: this.value
				});
			} else {
				this.$store.commit('UPDATE_FIELD', {
					id: this.chart.id,
					fieldname: this.name,
					value: this.value,
					renderd: this.value
				});
				this.$store.commit('RESET_ACTIVE_FIELD');
			}
		},
		cancel(){
			console.log('emit cancel');
			if(this.field.default && this.value.length == 0) {
				this.value = this.field.default;
			}
			this.$emit('cancel', this.name);
		},
		changeFile(event){
			this.fileEl = event.target;
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/v-field.vue